var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bannerText"},[_c('BannerTitle',{attrs:{"ch":_vm.ch,"en":_vm.en}},[(_vm.isShowNav && !_vm.isMobile)?_c('BannerNav',_vm._g(_vm._b({},'BannerNav',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }